import React, { useEffect, useState } from "react";
import "./NewRequestAlert.css";
import estbn from "../../assets/images/ESTBN.png";
import esCircle from "../../assets/images/Smoll_ESTBN_Logo.png";

const alertConfig = {
  sos: {
    label: "New SOS Request!",
    sub: "طلب مساعدة جديد على الطريق",
  },
  maintenance: {
    label: "New Maintenance Request!",
    sub: "طلب صيانة جديد وصل",
  },
  otherServices: {
    label: "New Service Request!",
    sub: "طلب خدمة جديد وصل",
  },
  helpRequests: {
    label: "New Help Request!",
    sub: "طلب مساعدة جديد وصل",
  },
};

const NewRequestAlert = ({ trigger }) => {
  const [visible, setVisible] = useState(false);
  const [animOut, setAnimOut] = useState(false);
  const [config, setConfig] = useState(null);
  const [phase, setPhase] = useState(1);

  const handleClose = () => {
    setAnimOut(true);
    setTimeout(() => {
      setVisible(false);
      setAnimOut(false);
      setPhase(1);
    }, 400);
  };

  useEffect(() => {
    if (!trigger) return;
    const cfg = alertConfig[trigger.key];
    if (!cfg) return;
    setConfig(cfg);
    setAnimOut(false);
    setPhase(1);
    setVisible(true);

    // phase 2: circle logo fades out, full logo fades in
    const p2 = setTimeout(() => setPhase(2), 1800);
    const close = setTimeout(() => handleClose(), 5500);
    return () => {
      clearTimeout(p2);
      clearTimeout(close);
    };
  }, [trigger]);

  if (!visible || !config) return null;

  return (
    <div
      className={`nra-overlay ${animOut ? "nra-overlay-out" : ""}`}
      onClick={handleClose}
    >
      <div
        className={`nra-card ${animOut ? "nra-card-out" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* ---- bg mesh ---- */}
        <div className="nra-mesh" />

        {/* ---- ripples ---- */}
        <div className="nra-ripple" />
        <div className="nra-ripple nra-ripple-2" />
        <div className="nra-ripple nra-ripple-3" />

        {/* ---- corner accent lines ---- */}
        <div className="nra-corner nra-corner-tl" />
        <div className="nra-corner nra-corner-tr" />
        <div className="nra-corner nra-corner-bl" />
        <div className="nra-corner nra-corner-br" />

        {/* ---- logo area ---- */}
        <div className="nra-logo-stage">
          {/* Phase 1 — circle icon drops in and pulses */}
          <div className={`nra-phase1 ${phase === 2 ? "nra-phase1-out" : ""}`}>
            <div className="nra-circle-glow" />
            <img src={esCircle} alt="ESTBN" className="nra-circle-img" />
          </div>

          {/* Phase 2 — full logo slides up */}
          <div className={`nra-phase2 ${phase === 2 ? "nra-phase2-in" : ""}`}>
            <img src={estbn} alt="ESTBN" className="nra-full-logo" />
            <div className="nra-logo-shine" />
          </div>
        </div>

        {/* ---- divider ---- */}
        <div className="nra-divider" />

        {/* ---- text ---- */}
        <div className="nra-text-block">
          <p className="nra-label">{config.label}</p>
          <p className="nra-sub">{config.sub}</p>
        </div>

        {/* ---- progress ---- */}
        <div className="nra-progress-track">
          <div className="nra-progress-bar" />
        </div>

        {/* ---- dismiss ---- */}
        <span className="nra-dismiss" onClick={handleClose}>
          ✕ dismiss
        </span>
      </div>
    </div>
  );
};

export default NewRequestAlert;
